import { XdrSearchEventDetailsPanelWebComponent } from './component/XdrSearchEventDetailsPanelWebComponent';
import { WEB_COMPONENT_XDR_SEARCH_EVENT_DETAILS_PANEL } from '../../webcomponents.constants';

export { XdrSearchEventDetailsPanelWebComponent };

window.customElements.define(WEB_COMPONENT_XDR_SEARCH_EVENT_DETAILS_PANEL, XdrSearchEventDetailsPanelWebComponent);
